import CandidateGroupTypes from 'redux/candidate-group/types';

const initialState = {
  candidateGroups: { data: null },
  fetchingCandidateGroups: true,
  savingCandidateGroup: false,
  updatingCandidateGroup: false,
  deletingCandidateGroup: false,
  savingTableData: false,
};

function candidateGroupReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CandidateGroupTypes.CREATE_CANDIDATE_GROUP:
      return {
        ...state,
        savingCandidateGroup: true,
      };
    case CandidateGroupTypes.CREATE_CANDIDATE_GROUP_SUCCESS:
      return {
        ...state,
        candidateGroups: {
          ...state.candidateGroups,
          data: [payload, ...state.candidateGroups.data],
        },
        savingCandidateGroup: false,
      };
    case CandidateGroupTypes.CREATE_CANDIDATE_GROUP_FAILURE:
      return {
        ...state,
        savingCandidateGroup: false,
      };

    // Edit Group Start
    case CandidateGroupTypes.EDIT_CANDIDATE_GROUP:
      return {
        ...state,
        updatingCandidateGroup: true,
      };
    case CandidateGroupTypes.EDIT_CANDIDATE_GROUP_SUCCESS:
      return {
        ...state,
        updatingCandidateGroup: false,
        candidateGroups: {
          ...state.candidateGroups,
          data: state.candidateGroups?.data?.map((group) => {
            if (group.id === payload.id) return { ...group, ...payload };
            return group;
          }),
        },
      };
    case CandidateGroupTypes.EDIT_CANDIDATE_GROUP_FAILURE:
      return {
        ...state,
        updatingCandidateGroup: false,
      };

    // Delete Group Start
    case CandidateGroupTypes.DELETE_CANDIDATE_GROUP:
      return {
        ...state,
        deletingCandidateGroup: true,
      };
    case CandidateGroupTypes.DELETE_CANDIDATE_GROUP_SUCCESS:
      return {
        ...state,
        deletingCandidateGroup: false,
        candidateGroups: {
          ...state.candidateGroups,
          data: state.candidateGroups?.data?.filter(
            (group) => group.id !== payload.id
          ),
        },
      };
    case CandidateGroupTypes.DELETE_CANDIDATE_GROUP_FAILURE:
      return {
        ...state,
        deletingCandidateGroup: false,
      };

    // Fetch Group Start
    case CandidateGroupTypes.FETCH_CANDIDATE_GROUP:
      return {
        ...state,
        fetchingCandidateGroups: true,
      };
    case CandidateGroupTypes.FETCH_CANDIDATE_GROUP_SUCCESS:
      return {
        ...state,
        fetchingCandidateGroups: false,
        candidateGroups: payload,
      };
    case CandidateGroupTypes.FETCH_CANDIDATE_GROUP_FAILURE:
      return {
        ...state,
        fetchingCandidateGroups: false,
      };

    // Update table data
    case CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS:
      return {
        ...state,
        savingTableData: true,
      };
    case CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS_SUCCESS:
      return {
        ...state,
        savingTableData: false,
      };
    case CandidateGroupTypes.UPDATE_CANDIDATE_GROUP_HEADERS_FAILURE:
      return {
        ...state,
        savingTableData: false,
      };
    default:
      return state;
  }
}

export default candidateGroupReducer;
